import { useEffect, useMemo, useState } from 'react';
import { fieldTypes } from '../../constants/globals';
import EditSettingsForm from './EditSettingsForm';
import {
  getOrderNumbers,
  metaDataFilter,
  numberOfBasicFilters,
  validateArrayOfObjects,
  validationConfigFilters,
  validationConfigTables,
} from './utils';

const EditSettingsFormContainer = (props) => {
  const {
    settings,
    onSubmit,
    formType,
    type,
    reference,
    submitRef,
    translations,
  } = props || {};

  const [settingsPayload, setSettingsPayload] = useState([]);
  const [errors, setErrors] = useState([]);

  const filteredSettings = useMemo(
    () => settings.filter((item) => item.type !== fieldTypes.ACTION),
    [settings]
  );

  const orderNumbers = useMemo(
    () =>
      filteredSettings?.map((s, index) => ({ id: s.id, orderNum: ++index })),
    [filteredSettings]
  );

  useEffect(() => {
    setSettingsPayload(filteredSettings);
  }, [filteredSettings]);

  const onComboBoxChangeHandler = (fieldType, field, value, errorIndex) => {
    const adjustedErrorIndex =
      metaDataFilter({ field: field }) && type
        ? errorIndex + numberOfBasicFilters(settingsPayload)
        : errorIndex;

    setSettingsPayload((prevState) =>
      prevState?.map((p) => (p.field === field ? { ...p, orderNum: value } : p))
    );
    removeErrors(fieldType, adjustedErrorIndex);
  };

  const onCheckBoxChangeHandler = (event, field) => {
    const { name, checked } = event?.target || {};
    setSettingsPayload((prevState) =>
      prevState?.map((p) => {
        const isDisabled = name === 'enabled' && !checked;
        return p.field === field
          ? {
              ...p,
              [name]: checked,
              orderNum: isDisabled ? 0 : p.orderNum,
            }
          : p;
      })
    );
  };

  const onInputChangeHandler = (
    event,
    field,
    id,
    fieldName,
    type,
    errorIndex
  ) => {
    const adjustedErrorIndex =
      type && metaDataFilter({ field: fieldName })
        ? numberOfBasicFilters(settingsPayload) + errorIndex
        : errorIndex;

    removeErrors(field, adjustedErrorIndex);

    const { value } = event.target;
    const newFilterSettingsPayload = [...settingsPayload];
    const index = newFilterSettingsPayload.findIndex((item) => item.id === id);
    let typedValue = value;
    if (type === fieldTypes.NUMBER) {
      typedValue = +value > 0 ? +value : '';
    }
    newFilterSettingsPayload[index] = {
      ...newFilterSettingsPayload[index],
      [field]: typedValue,
    };
    setSettingsPayload(newFilterSettingsPayload);
  };

  const onSubmitHandler = (event) => {
    event.preventDefault();

    let errors = validate();
    if (errors.length > 0) {
      setErrors(errors);
      return;
    }
    onSubmit(settingsPayload);
  };

  function validate() {
    const config =
      reference === formType.FILTERS || formType.META_DATA_FILTERS
        ? validationConfigFilters
        : validationConfigTables;

    const errors = validateArrayOfObjects(
      settingsPayload,
      config,
      translations.Errors
    );
    return errors;
  }

  function removeErrors(field, errorIndex) {
    const newErrors = errors ? [...errors] : [];

    const indexOfErrorToRemove = newErrors.findIndex(
      (item) => item.property === field && item.index === errorIndex
    );
    if (indexOfErrorToRemove !== -1) {
      newErrors.splice(indexOfErrorToRemove, 1);
    }
    setErrors(newErrors);
  }

  function getComboOrderNumbers(item) {
    return getOrderNumbers(item, settingsPayload, orderNumbers);
  }

  return (
    <EditSettingsForm
      translations={translations}
      submitRef={submitRef}
      type={type}
      reference={reference}
      formType={formType}
      onSubmitHandler={onSubmitHandler}
      settingsPayload={settingsPayload}
      onInputChangeHandler={onInputChangeHandler}
      errors={errors}
      onCheckBoxChange={onCheckBoxChangeHandler}
      orderNumbers={orderNumbers}
      onComboBoxChange={onComboBoxChangeHandler}
      getComboOrderNumbers={getComboOrderNumbers}
    />
  );
};

export default EditSettingsFormContainer;
